import {
  fetchGetContentList,
  cleanUpMessageList,
  cleanUpList,
} from 'state-managament/list.slice';
import { useDispatch, useSelector } from 'react-redux';
import {
  serviceGetInventories,
  serviceGetTemplates,
  serviceGetDocuments,
  serviceGetCredentials,
  serviceGetDataModels,
  serviceGetProjects,
  serviceGetUsers,
  serviceGetCompanies,
  serviceGetJobs,
  serviceGetRoles
 } from 'utils';

const servicesTypeMap = {
  templates: serviceGetTemplates,
  dataModels: serviceGetDataModels,
  inventories: serviceGetInventories,
  documents: serviceGetDocuments,
  credentials: serviceGetCredentials,
  projects: serviceGetProjects,
  users: serviceGetUsers,
  companies: serviceGetCompanies,
  jobs: serviceGetJobs,
  roles: serviceGetRoles
};

export default function useList(serviceListType) {
  const setUpGetContentService = servicesTypeMap[serviceListType];
  const { content, error, success, isLoaded } = useSelector(
    (state) => state.list
  );
  const dispatch = useDispatch();

  const getContentList = (args) => {
    dispatch(fetchGetContentList(setUpGetContentService, args, serviceListType));
  };

  const cleanUp = () => dispatch(cleanUpList());
  const cleanUpMessage = () => dispatch(cleanUpMessageList());

  return {
    getContentList,
    content,
    error,
    success,
    isLoaded,
    cleanUp,
    cleanUpMessage,
  };
}
